// ===== Module features for easy import in ClientContainer=====

import StocksAnalyticsContainer from './StocksAnalytics';
import StocksAnalyticsCurrent from './StocksAnalytics/StocksAnalyticsCurrent';
import StocksAnalyticsPast from './StocksAnalytics/StocksAnalyticsPast';

import StocksInventoriesContainer from './StocksInventories';
import StocksInventoriesLosses from './StocksInventories/StocksInventoriesLosses';
import StocksInventoriesStocks from './StocksInventories/StocksInventoriesStocks';
import StocksInventoriesTransfer from './StocksInventories/StocksInventoriesTransfer';
import Transfers from './StocksInventories/Transfers';
import TransfersCreation from './StocksInventories/Transfers/components/TransfersCreation';
import TransfersDetails from './StocksInventories/Transfers/components/TransfersDetails';

const StocksModule = {
  StocksAnalyticsContainer,
  StocksAnalyticsCurrent,
  StocksAnalyticsPast,
  StocksInventoriesContainer,
  StocksInventoriesStocks,
  StocksInventoriesTransfer,
  StocksInventoriesLosses,
  Transfers,
  TransfersDetails,
  TransfersCreation,
};

export default StocksModule;
